/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfHoursV1ExceptionState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_HOURS_V1_EXCEPTION_STATE_ENTITY_NAME = 'ixf.hours.v1.Exception';
export const ixfHoursV1ExceptionStateEntity = new schema.Entity<IxfHoursV1ExceptionState>(IXF_HOURS_V1_EXCEPTION_STATE_ENTITY_NAME, {}, { idAttribute: 'exceptionId' });

